<div class="table-responsive always-scroll">
  <table class="table table-striped align-middle dashboard-table">
    <thead>
      <tr>
        <th>Benutzer</th>
        <th>E-Mail</th>
        <th>Stellenbezeichnung</th>
        <th>Kategorie</th>
        <th>Lebenslauf</th>
        <th>Status</th>
        <th>Bewerbungsdatum</th>
        <th>Aktionen</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let app of applications" class="application-row">
        <td>{{ app.user.fullName }}</td>
        <td>{{ app.user.email }}</td>
        <td>{{ app.job.title }}</td>
        <td>{{ app.job.category }}</td>
        <td>
          <a [href]="app.cvUrl" target="_blank">Lebenslauf anzeigen</a>
        </td>
        <td>
          <select 
            class="form-select form-select-sm"
            [(ngModel)]="app.status"
            (change)="updateApplicationStatus(app, app.status)"
            style="width: 90px;"
            >
            <option value="pending">Ausstehend</option>
            <option value="accepted">Angenommen</option>
            <option value="rejected">Abgelehnt</option>
          </select>
        </td>
        <td>{{ app.applicationDate?.toDate() | date:'short' }}</td>
        <td>
          <a [routerLink]="['/Admin/ApplicationDetails', app.id]" class="btn btn-sm btn-outline-primary me-2">
            <i class="fa-solid fa-eye"></i>
          </a>
          <button class="btn btn-sm btn-outline-danger" (click)="confirmDelete(app.id!)">
            <i class="fa-solid fa-trash-can"></i>
          </button>
        </td>
      </tr>

      <tr *ngIf="applications.length === 0 && !showSpinner" style="text-align: center;">
        <td colspan="8" class="text-muted">Keine Bewerbungen verfügbar</td>
      </tr>

      <tr *ngIf="showSpinner" style="text-align: center;">
        <td colspan="8">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Lädt...</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>